import { Add } from '@tunasong/icons'
import type { TunaPlugin } from '@tunasong/plugin-lib'
import { useAllowedChildEntityTypes, usePlugins } from '@tunasong/plugin-lib'
import type { Entity, Persisted } from '@tunasong/schemas'
import { Button, type ButtonProps, useDimensions } from '@tunasong/ui-lib'
import type { FC } from 'react'
import React, { useState } from 'react'
import { CreateEntityDialog } from './create-entity-dialog.js'

export interface CreateEntityFabProps extends ButtonProps {
  plugins?: TunaPlugin[]
  parent: Persisted<Entity>
}

export const CreateEntityButton: FC<CreateEntityFabProps> = props => {
  const { plugins: providedPlugins, parent, ...restProps } = props
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const handleClose = () => setAnchorEl(null)
  const handleToggleDial = (ev: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(ev.currentTarget)
  const { isSmallOrSmaller } = useDimensions()

  const allPlugins = usePlugins()
  const plugins = providedPlugins ?? allPlugins ?? []

  const entityTypes = useAllowedChildEntityTypes(parent, plugins)
  const ref = React.useRef<HTMLButtonElement>(null)

  const color = 'primary' // hover ? 'primary' : 'inherit'

  return entityTypes.length > 0 ? (
    <>
      <Button {...restProps} ref={ref} color={color} onClick={handleToggleDial} endIcon={<Add />} aria-label="New item">
        {isSmallOrSmaller ? '' : 'New'}
      </Button>
      <CreateEntityDialog open={Boolean(anchorEl)} onClose={handleClose} plugins={plugins} parent={parent} />
    </>
  ) : null
}

export default CreateEntityButton
